import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRelatedVideos } from "../../features/relatedVideos/relatedVideosSlice";
import Loading from "../ui/Loading";
import RelatedVideoListItem from "./RelatedVideoListItem";

const RelatedVideoList = ({ tags, currentVideoId }) => {
    const dispatch = useDispatch();
    const { relatedVideos, isLoading, isError, error } = useSelector(
        (state) => state.relatedVideos
    );

    useEffect(() => {
        dispatch(fetchRelatedVideos({ tags, id: currentVideoId }));
    }, [dispatch, tags, currentVideoId]);

    //decide what to render
    let content;

    if (isLoading)
        content = (
            <div className="w-14 ml-[200px] mt-[100px]">
                <Loading />
            </div>
        );

    if (!isLoading && isError)
        content = <div className="col-span-12">{error}</div>;

    if (!isLoading && !isError && relatedVideos.length === 0)
        content = <div className="col-span-12">No related videos found.</div>;

    if (!isLoading && !isError && relatedVideos.length > 0)
        content = relatedVideos?.map((video) => (
            <RelatedVideoListItem key={video.id} videoInfo={video} />
        ));

    return (
        <div className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto">
            {content}
        </div>
    );
};

export default RelatedVideoList;
